import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "../utils/cn";
import CheckmarkIcon from "../icons/18px/checkmark";
import MinusIcon from "../icons/18px/minus";

// Unchecked: gray outline on the surface. Checked / indeterminate: brand fill
// with a white mark. Disabled: muted gray, checked or not. Focus ring matches
// the pill Buttons.
const checkboxClassName =
  "peer flex size-4 shrink-0 items-center justify-center rounded border border-border-tertiary bg-bg-primary text-action-primary-foreground transition-colors outline-none focus-visible:ring-[3px] focus-visible:ring-brand-border disabled:cursor-not-allowed disabled:border-border-secondary disabled:bg-bg-tertiary data-[state=checked]:border-action-primary data-[state=checked]:bg-action-primary data-[state=indeterminate]:border-action-primary data-[state=indeterminate]:bg-action-primary disabled:data-[state=checked]:border-transparent disabled:data-[state=checked]:bg-icon-disabled disabled:data-[state=indeterminate]:border-transparent disabled:data-[state=indeterminate]:bg-icon-disabled aria-invalid:border-status-error-solid";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(checkboxClassName, className)}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="group/indicator flex items-center justify-center text-current">
      <CheckmarkIcon className="size-3 group-data-[state=indeterminate]/indicator:hidden [&_path]:stroke-[2.5]" />
      <MinusIcon className="hidden size-3 group-data-[state=indeterminate]/indicator:block [&_path]:stroke-[2.5]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
